import { IntlShape } from 'react-intl';
import { z } from 'zod';
import { QueueAction } from '@rossum/api-client/schemas';
import { IconSchoolOff } from '@rossum/ui/icons/tabler';
import { createForm } from './createForm';
import { createHeader } from './createHeader';

const excludeFromAiTrainingActionPayloadSchema = (_intl?: IntlShape) =>
  z.object({}).optional();

const ExcludeFromAiTrainingActionForm = createForm(
  _props => null,
  (intl?: IntlShape) => excludeFromAiTrainingActionPayloadSchema(intl)
);

const ExcludeFromAiTrainingActionHeader = createHeader(
  ({ RenderComponent }) => <RenderComponent entries={[]} />,
  (intl?: IntlShape) => excludeFromAiTrainingActionPayloadSchema(intl)
);

export const excludeFromAiTrainingAction = {
  icon: IconSchoolOff,
  intlKey: 'excludeFromAiTraining' as const,
  resolveAction: (a: QueueAction) => a.type === 'exclude_from_training',
  serialized: { type: 'exclude_from_training' as const },
  groupIntlKey: 'automation' as const,
  form: ExcludeFromAiTrainingActionForm,
  header: ExcludeFromAiTrainingActionHeader,
  supportedEvents: [
    'annotation_confirmed',
    'annotation_import_succeeded',
    'annotation_import_failed',
    'annotation_exported',
    'annotation_export_succeeded',
    'annotation_export_failed',
  ] as const,
  payloadSchema: (intl?: IntlShape) =>
    excludeFromAiTrainingActionPayloadSchema(intl),
};
